import type { ComparisonRelation } from "../../../shared/contracts/product-pages.js";

export function ComparisonTestHistory({
  relation,
}: {
  relation: ComparisonRelation;
}): React.JSX.Element | null {
  if (!relation.testRounds?.length) return null;
  return (
    <section aria-label="Test rounds" className="rc-analysis">
      <h3>Starting record · test rounds</h3>
      {relation.testRounds.map((round, index) => (
        <article className="rc-observation" key={round.id}>
          <h3>
            {round.courseName} · Test round {index + 1}
          </h3>
          <p>{relation[round.winner].name} won</p>
          <small>Test · starting score only</small>
        </article>
      ))}
    </section>
  );
}
